var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "#57454A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.5459 21.8845C21.137 21.2089 20.8881 20.4089 20.8881 19.5555C20.8881 17.1022 22.8793 15.1111 25.3326 15.1111H27.1103C29.7947 15.1111 30.6659 13.3334 30.6659 13.3334C30.6659 13.3334 31.6437 24.0001 25.3326 24.0001C24.4614 24.0001 23.6614 23.7511 22.9859 23.3245C22.5593 24.4622 21.937 26.4534 21.6347 28.5868C23.8747 28.9778 27.299 31.7334 27.5 34C30.5044 31.92 34.2426 26.1689 34.2426 22.2222H36.7648C36 31 29.3147 39.1111 19.9993 39.1111C10.6837 39.1111 3.11035 31.5378 3.11035 22.2222C3.11035 12.9067 10.6837 5.33336 19.9993 5.33336L20 2L24 6.75L20 11.5L19.9993 8.00003C10 8.61745 5.71048 15.5201 5.71048 21.8845C5.71048 26 7.97779 30.9021 11 33C12.5 30 16 28.5868 18.737 28.5334C18.577 27.3067 18.2747 26.0089 17.8659 24.9245C17.2437 25.4578 16.4437 25.7778 15.5548 25.7778C13.5992 25.7778 11.9992 24.1778 11.9992 22.2222V20.4622C11.9992 19.4667 11.6615 18.5245 11.1104 17.7778C11.1104 17.7778 19.0214 17.3689 19.1103 22.2222C19.1103 22.7378 19.0037 23.2178 18.8081 23.6445C18.0614 23.0755 17.2793 22.5778 16.4437 22.2222C17.4747 22.9867 18.8793 24.6578 19.9993 26.8445C21.1903 23.9645 22.9859 21.0311 25.3326 18.6667C23.9814 19.5911 22.7193 20.6578 21.5459 21.8845Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.4248514b66e004361f37553b0c36f587.svg";
export { ForwardRef as ReactComponent };